import { typeUniqueId } from "../../../../dataObjects/types"
import { ICategory, ICategoryAsJson } from "../../../../dataObjects/models/categories/Category";
import { IFirestoreCategoryRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreCategoryRepository";
import { FirestoreDataRepositoryFactory } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreDataRepositoryFactory";
import { enumFirestoreDataRepositoryDataType } from "../../../cloudServices/googleFirebaseServices/database/firestore/enums";
import { IFirestoreBaseRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreBaseRepository";


export function getCategoryObjectUsingId(categoryId: typeUniqueId): Promise<ICategory | undefined> {
  return new Promise<ICategory | undefined>(async (resolve, reject) => {
    try {
      // get a Category repository from the repository factory
      const firestoreCategoryRepository: IFirestoreCategoryRepository =
        FirestoreDataRepositoryFactory.CreateDataRepository(enumFirestoreDataRepositoryDataType.Category) as
        IFirestoreBaseRepository<ICategory, ICategoryAsJson>;

      // make request of the repository to get the Category object associated with the Id
      const category: ICategory | undefined = await firestoreCategoryRepository.get(categoryId);

      resolve(category);
    } catch (error: any) {
      reject(error);
    }
  });
}